import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AngularFireModule } from "@angular/fire/compat";
import { AngularFireStorageModule } from '@angular/fire/compat/storage';

import { AuthInterceptor } from 'src/app/_helpers/auth.interceptor';
import { AppRoutingModule } from './app-routing.module';

import { environment } from "../environments/environment";
import { initializeApp } from "firebase/app";
initializeApp(environment.firebase);

import { AppComponent } from './app.component';
import { ContentAnimateDirective } from './shared/directives/content-animate.directive';
import { NavbarComponent } from './shared/navbar/navbar.component';
import { SidebarComponent } from './shared/sidebar/sidebar.component';
import { FooterComponent } from './shared/footer/footer.component';
import { SpinnerComponent } from './shared/spinner/spinner.component';
import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ExcelService } from './_services/excel.service';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { NgImageSliderModule } from 'ng-image-slider';
import { NgxPaginationModule } from 'ngx-pagination';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { SendNotificationComponent } from './shared/send-notification/send-notification.component';
import { NotificationAlertComponent } from './shared/notification-alert/notification-alert.component';
import { CustomersListingComponent } from './shared/customers-listing/customers-listing.component';
import { AdminFeeComponent } from './admin-fee/admin-fee.component';
import { VendorAllEarningComponent } from './vendor-all-earning/vendor-all-earning.component';
import { VendorsRevenueComponent } from './vendors-revenue/vendors-revenue.component';

@NgModule({
  declarations: [
    AppComponent,
    ContentAnimateDirective,
    NavbarComponent,
    SidebarComponent,
    FooterComponent,
    SpinnerComponent,
    LoginComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    PrivacyPolicyComponent,
    SendNotificationComponent,
    NotificationAlertComponent,
    CustomersListingComponent,
    AdminFeeComponent,
    VendorAllEarningComponent,
    VendorsRevenueComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    LoadingBarHttpClientModule,
    SweetAlert2Module,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireStorageModule,
    NgImageSliderModule,
    NgxPaginationModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule
  ],
  providers: [
    DeviceDetectorService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    ExcelService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
